export var PickUpLocationStatusEnum;
(function (PickUpLocationStatusEnum) {
    PickUpLocationStatusEnum[PickUpLocationStatusEnum["New"] = 1] = "New";
    PickUpLocationStatusEnum[PickUpLocationStatusEnum["VacanciesLeft"] = 2] = "VacanciesLeft";
    PickUpLocationStatusEnum[PickUpLocationStatusEnum["Booked"] = 3] = "Booked";
    PickUpLocationStatusEnum[PickUpLocationStatusEnum["Overbooked"] = 4] = "Overbooked";
    PickUpLocationStatusEnum[PickUpLocationStatusEnum["Closed"] = 5] = "Closed";
})(PickUpLocationStatusEnum || (PickUpLocationStatusEnum = {}));
